/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdLabel } from './IdLabel';
import {
    IdLabelFromJSON,
    IdLabelFromJSONTyped,
    IdLabelToJSON,
    IdLabelToJSONTyped,
} from './IdLabel';
import type { GenericColors } from './GenericColors';
import {
    GenericColorsFromJSON,
    GenericColorsFromJSONTyped,
    GenericColorsToJSON,
    GenericColorsToJSONTyped,
} from './GenericColors';

/**
 * 
 * @export
 * @interface RiskSummaryDto
 */
export interface RiskSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof RiskSummaryDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof RiskSummaryDto
     */
    date: Date;
    /**
     * 
     * @type {GenericColors}
     * @memberof RiskSummaryDto
     */
    statusColor: GenericColors;
    /**
     * 
     * @type {string}
     * @memberof RiskSummaryDto
     */
    statusLabel: string;
    /**
     * 
     * @type {IdLabel}
     * @memberof RiskSummaryDto
     */
    simulationIdentifier: IdLabel;
    /**
     * 
     * @type {IdLabel}
     * @memberof RiskSummaryDto
     */
    contractIdentifier?: IdLabel;
    /**
     * 
     * @type {Array<IdLabel>}
     * @memberof RiskSummaryDto
     */
    quoteIdentifiers?: Array<IdLabel>;
    /**
     * 
     * @type {Array<IdLabel>}
     * @memberof RiskSummaryDto
     */
    insureds?: Array<IdLabel>;
    /**
     * 
     * @type {string}
     * @memberof RiskSummaryDto
     */
    branchCode: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof RiskSummaryDto
     */
    products: Array<string>;
    /**
     * Provenance de la simulation — id pour matcher la facette simulationSource
     * @type {string}
     * @memberof RiskSummaryDto
     */
    sourceId?: string | null;
    /**
     * Code de provenance : ESPACE_PRO | ESPACE_MEMBRE (logique/badge)
     * @type {string}
     * @memberof RiskSummaryDto
     */
    sourceCode?: string | null;
    /**
     * Libellé affichable de la provenance (ex. « Espace pro »)
     * @type {string}
     * @memberof RiskSummaryDto
     */
    sourceLabel?: string | null;
    /**
     * Number of unread notifications for this simulation
     * @type {number}
     * @memberof RiskSummaryDto
     */
    unreadNotificationCount?: number;
    /**
     * Dossiers EMPRUNTEUR (EMP) uniquement : id du projet d'emprunt (au niveau racine, comme la liste devis). Sert aux routes emprunteur — ne plus déduire le projet d'un autre champ.
     * 
     * @type {string}
     * @memberof RiskSummaryDto
     */
    borrowerProjectId?: string | null;
    /**
     * Courtier propriétaire du dossier. Rempli uniquement en vue partagée (rôle Plateforme / portefeuille partagé) ; null/absent (WhenWritingNull) en vue courtier classique — sert de détecteur pour afficher la colonne « Courtier ».
     * 
     * @type {string}
     * @memberof RiskSummaryDto
     */
    brokerId?: string | null;
    /**
     * Nom du courtier (cf. brokerId). Renseigné en vue partagée uniquement.
     * @type {string}
     * @memberof RiskSummaryDto
     */
    brokerName?: string | null;
}



/**
 * Check if a given object implements the RiskSummaryDto interface.
 */
export function instanceOfRiskSummaryDto(value: object): value is RiskSummaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('statusColor' in value) || value['statusColor'] === undefined) return false;
    if (!('statusLabel' in value) || value['statusLabel'] === undefined) return false;
    if (!('simulationIdentifier' in value) || value['simulationIdentifier'] === undefined) return false;
    if (!('branchCode' in value) || value['branchCode'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    return true;
}

export function RiskSummaryDtoFromJSON(json: any): RiskSummaryDto {
    return RiskSummaryDtoFromJSONTyped(json, false);
}

export function RiskSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'statusColor': GenericColorsFromJSON(json['statusColor']),
        'statusLabel': json['statusLabel'],
        'simulationIdentifier': IdLabelFromJSON(json['simulationIdentifier']),
        'contractIdentifier': json['contractIdentifier'] == null ? undefined : IdLabelFromJSON(json['contractIdentifier']),
        'quoteIdentifiers': json['quoteIdentifiers'] == null ? undefined : ((json['quoteIdentifiers'] as Array<any>).map(IdLabelFromJSON)),
        'insureds': json['insureds'] == null ? undefined : ((json['insureds'] as Array<any>).map(IdLabelFromJSON)),
        'branchCode': json['branchCode'],
        'products': json['products'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'sourceCode': json['sourceCode'] == null ? undefined : json['sourceCode'],
        'sourceLabel': json['sourceLabel'] == null ? undefined : json['sourceLabel'],
        'unreadNotificationCount': json['unreadNotificationCount'] == null ? undefined : json['unreadNotificationCount'],
        'borrowerProjectId': json['borrowerProjectId'] == null ? undefined : json['borrowerProjectId'],
        'brokerId': json['brokerId'] == null ? undefined : json['brokerId'],
        'brokerName': json['brokerName'] == null ? undefined : json['brokerName'],
    };
}

export function RiskSummaryDtoToJSON(json: any): RiskSummaryDto {
    return RiskSummaryDtoToJSONTyped(json, false);
}

export function RiskSummaryDtoToJSONTyped(value?: RiskSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'date': ((value['date']).toISOString().substring(0,10)),
        'statusColor': GenericColorsToJSON(value['statusColor']),
        'statusLabel': value['statusLabel'],
        'simulationIdentifier': IdLabelToJSON(value['simulationIdentifier']),
        'contractIdentifier': IdLabelToJSON(value['contractIdentifier']),
        'quoteIdentifiers': value['quoteIdentifiers'] == null ? undefined : ((value['quoteIdentifiers'] as Array<any>).map(IdLabelToJSON)),
        'insureds': value['insureds'] == null ? undefined : ((value['insureds'] as Array<any>).map(IdLabelToJSON)),
        'branchCode': value['branchCode'],
        'products': value['products'],
        'sourceId': value['sourceId'],
        'sourceCode': value['sourceCode'],
        'sourceLabel': value['sourceLabel'],
        'unreadNotificationCount': value['unreadNotificationCount'],
        'borrowerProjectId': value['borrowerProjectId'],
        'brokerId': value['brokerId'],
        'brokerName': value['brokerName'],
    };
}

